﻿export function CySocket(config) {
  this.server = config ? config.server || 'wss://web.baby161.top/websocket' : 'wss://web.baby161.top/websocket'
  this.autoReconnect = config ? config.autoReconnect || '' : true
  var socket
  var times = 0// 尝试连接三次
  var interval
  var cySocket = this
  this.init = function(callback) {
    if (this.server === '') {
      console.error('服务器地址不能为空:)')
      return
    }
    console.log(config.server)
    if (interval) {
      clearInterval(interval)
      interval = null
      times = 0
    }
    try {
      if (socket && socket.readyState === 1) return
      socket = new WebSocket(this.server)
      socket.onopen = function(data) {
        if (config && config.openSocket) config.openSocket.call(cySocket, data)
      }
      socket.binaryType = 'arraybuffer'
      socket.onmessage = function(msg) {
        if (config && config.receiveMsg) config.receiveMsg.call(cySocket, msg.data)
      }
      interval = setInterval(function() {
        if (socket.readyState !== 1) {
          if (times > 2) {
            clearInterval(interval)
            interval = null
            times = 0
            // console.log("无法连接到服务器...:)");
            return
          } else {
            // console.log("通讯异常,正在尝试重连...:)");
            if (socket) {
              socket.close()
            }
            socket = new WebSocket(config.server)
          }
          times++
        } else {
          clearInterval(interval)
          interval = null
          times = 0
          // console.log("已经连接到服务器");
        }
      }, 5000)
      if (typeof (callback) === 'function') callback.call(cySocket)
    } catch (e) {
      console.log(e.message)
      if (this.autoReconnect) {
        this.init(callback)
      }
    }
  }

  this.close = function() {
    if (interval) {
      clearInterval(interval)
      interval = null
      times = 0
    }
    if (socket && socket.readyState === 1) {
      socket.close()
    }
  }

  this.sendMsg = function(data) {
    if (!socket || socket.readyState !== 1) {
      this.init(config)
    }
    var arrayBuffer = new ArrayBuffer(data.length + 6)
    var dataView = new DataView(arrayBuffer)
    dataView.setInt32(0, data.length + 6, true)// 指定小端，主机字节序设置
    for (var i = 0; i < data.length; i++) {
      dataView.setUint8(i + 4, data[i])
    }
    dataView.setUint8(dataView.byteLength - 2, 0x0D)
    dataView.setUint8(dataView.byteLength - 1, 0x0A)
    if (socket && socket.readyState === 1) { socket.send(dataView.buffer) }
  }
  this.checkSocketState = function() {
    return socket.readyState
  }
}
